var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{staticClass:"from-label",domProps:{"innerHTML":_vm._s(_vm.blockLabel)}}),_c('vue-slider',{ref:"slider",attrs:{"data":_vm.data,"tooltip-placement":'bottom',"tooltip":'always',"dotSize":[28, 28],"min-range":1,"enableCross":false,"marks":true,"contained":true},scopedSlots:_vm._u([{key:"dot",fn:function(ref){
var value = ref.value;
var focus = ref.focus;
return [_c('div',{staticClass:"custom-dot-inner"})]}},{key:"step",fn:function(ref){
var label = ref.label;
var active = ref.active;
return [_c('div',{class:['custom-step', { active: active }]})]}},{key:"label",fn:function(ref){
var label = ref.label;
var active = ref.active;
return [_c('div',{class:['vue-slider-mark-label', 'custom-label', { active: active }]},[_vm._v(_vm._s(_vm.getValue(label, false)))])]}},{key:"tooltip",fn:function(ref){
var value = ref.value;
return [_c('div',{staticClass:"custom-tooltip"},[_vm._v(_vm._s(_vm.getValue(value, true)))])]}}]),model:{value:(_vm.selectedValue),callback:function ($$v) {_vm.selectedValue=$$v},expression:"selectedValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }